import { ChangeEvent, useCallback, useEffect, useState } from 'react';

import Modal from '../../../../components/modal/modal';
import Button from '../../../../components/button/button';
import { Role } from '../../../../types/role.type';

import styles from './update-role-modal.module.scss';

type Props = {
    roles: Role[];
    operatorRoleId?: number;
    shown: boolean;
    onConfirm: (roleId: number) => void;
    onDiscard: () => void;
};

const UpdateRoleModal = ({
    roles,
    operatorRoleId,
    shown,
    onConfirm,
    onDiscard,
}: Props) => {
    const [roleId, setRoleId] = useState<number>();

    useEffect(() => {
        operatorRoleId && setRoleId(operatorRoleId);
    }, [operatorRoleId]);

    const handleConfirm = useCallback(() => {
        if (!roleId) return;
        onConfirm(roleId);
    }, [roleId]);

    const handleSelectChange = useCallback(
        (ev: ChangeEvent<HTMLSelectElement>) => {
            setRoleId(Number(ev.target.value));
        },
        []
    );

    const isButtonDisabled: () => boolean = useCallback(() => {
        return roleId === operatorRoleId;
    }, [roleId, operatorRoleId]);

    return (
        <Modal shown={shown} onDiscard={onDiscard}>
            <div className={styles.modal}>
                <h4>Actualizar rol</h4>
                <select onChange={handleSelectChange}>
                    {roles.map((role) => (
                        <option
                            value={role.id}
                            selected={role.id === operatorRoleId}
                        >
                            {role.name}
                        </option>
                    ))}
                </select>
                <Button
                    onPress={handleConfirm}
                    width="100%"
                    disabled={isButtonDisabled()}
                >
                    <span>Actualizar</span>
                </Button>
            </div>
        </Modal>
    );
};

export default UpdateRoleModal;
